import { PortalProvider } from '../contexts/PortalContext';
import type { PortalKind } from '../lib/portal';
import { RequireAuth } from './RequireAuth';
import { RequirePortalChoice } from './RequirePortalChoice';
import { AccountsAppShell } from './layout/AccountsAppShell';

export function AccountsPortalApp({ kind }: { kind: PortalKind }) {
  return (
    <PortalProvider kind={kind}>
      <RequireAuth>
        <RequirePortalChoice>
          <AccountsAppShell />
        </RequirePortalChoice>
      </RequireAuth>
    </PortalProvider>
  );
}
